import Modal from "@/components/common/modal";
import { TextAreaField } from "@/components/common/text-field";
import { DialogFooter } from "@/components/ui/dialog";
import {
  type DeactivateFormData,
  schema,
} from "@/schemas/users/deactivate-user";
import { cn } from "@/utils/theme";
import { Button /*Icon*/, Icon } from "@elaniintc/goes-design-system";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onAccept: (val: { reason: string }) => void;
  onClose: () => void;
}

const DeactivateTableModal = ({
  isOpen,
  isLoading,
  onAccept,
  onClose,
}: Props) => {
  const {
    register,
    watch,
    handleSubmit,
    reset,
    //setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm<DeactivateFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      reason: "",
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [reason] = watch(["reason"]);

  const onSubmit = async (data: DeactivateFormData) => {
    onAccept({
      reason: data.reason,
    });
  };

  const handleClose = () => {
    reset({
      reason: "",
    }); // Reset form values when closing the modal
    clearErrors();
    onClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Desactivar tabla"
      description="¿Estás seguro de que deseas desactivar la tabla? Se ocultará de la vista principal y no podrás usar sus datos."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <form
        className="flex flex-col gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onSubmit)(e);
        }}
        id="edit-role-form"
      >
        <TextAreaField
          label="¿Por qué desactivas esta tabla?"
          required
          placeholder="Escribe la razón de la desactivación del usuario"
          className="relative h-[88px] max-h-[88px]"
          {...register("reason")}
          limit={120}
          maxLength={120}
          count={reason?.length || 0}
          error={errors.reason?.message}
        />
        <DialogFooter className="pt-1">
          <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
            <Button
              size="lg"
              type="button"
              className="w-full rounded-lg"
              variant="tertiary"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              size="lg"
              variant="danger-secondary"
              className="w-full rounded-lg"
              type="submit"
              disabled={!isValid || isLoading}
            >
              Desactivar
              {isLoading && (
                <Icon
                  type="far"
                  name={"spinner-third"}
                  className={cn("text-current", "animate-spin")}
                />
              )}
            </Button>
          </div>
        </DialogFooter>
      </form>
    </Modal>
  );
};

export default DeactivateTableModal;
